import { render, staticRenderFns } from "./ListaVentas.vue?vue&type=template&id=215084c3&scoped=true"
import script from "./ListaVentas.vue?vue&type=script&lang=js"
export * from "./ListaVentas.vue?vue&type=script&lang=js"
import style0 from "./ListaVentas.vue?vue&type=style&index=0&id=215084c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215084c3",
  null
  
)

export default component.exports